/* global window */
import { Formik, Form } from 'formik';
import React from 'react';

import { formatApiError, submitSubscribe } from '../../helpers/apiHelper';

import FormGeneral from './FormGeneral';
import { validateSubmit } from './validators';

const NewsletterForm = (props) => {
  const { onFormSuccess, onFormError } = props;
  const handleSubmit = async (values, formik) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'formSubmission', form: 'subscribe' });
    const data = transformValues(values);
    data.hubspotFormId = 'a6ef26b6-fcd2-4ca3-aa15-01e71a10bd2d';
    try {
      await submitSubscribe(data);
      formik.setSubmitting(false);
      onFormSuccess();
    } catch (error) {
      const errorMessage = formatApiError(error);
      onFormError(errorMessage);
      formik.setSubmitting(false);
    }
  };

  return (
    <Formik
      validate={validate}
      initialValues={getInitialValues()}
      onSubmit={handleSubmit}
    >
      <Form>
        <FormGeneral />
      </Form>
    </Formik>
  );
};

const transformValues = (values) => {
  const data = { ...values };
  return data;
};

const validate = (values) => {
  const data = transformValues(values);
  const errors = validateSubmit(data);
  return errors;
};

const getInitialValues = () => ({
  email: ''
});

export default NewsletterForm;
